wbApp.filter('userRole', ['userRolesSvc', function (userRolesSvc) {
    return function (input) {
        if (input) {
            var res = userRolesSvc.get(input);
            if (res) {
                return res.name;
            }
        }

        return input;
    };
}]);